export const LOCAL = 'local'
export const DEVELOPMENT = 'development'
export const PRODUCTION = 'production'
